import { Slider, type SliderProps } from '@chakra-ui/react';

export type UiSliderProps = SliderProps;

export const UiSlider = Slider;
